import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/ohmelec.webp")